import { Component, OnInit,  Input, ViewEncapsulation } from '@angular/core';
import { PopupService } from '../../../services/shared/popup.service';
import { PermitTypeService } from '../../../services/permit-type.service';
import { CurrencyFormat } from '../../../pipes/currencyFormat.pipe';
import { environment } from '../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'app/services/application.service';
import { PermitService } from 'app/services/permit.service'
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { Account } from 'app/constants/account.enum';
import { Subject } from 'rxjs';
import { CarrierService } from 'app/services/carrier.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';



@Component({
  selector: 'permit-type-viewer',
  templateUrl: './permit-type-viewer.component.html',
  styleUrls: ['./permit-type-viewer.component.css'],
  providers: [PermitTypeService, PopupService, CurrencyFormat],
  encapsulation: ViewEncapsulation.None
})
export class PermitTypeViewerComponent implements OnInit {
  @Input('ctrlData') ctrlData: any;

  permittype: any = [];
  selectedIndex:any;
  editMode:boolean;
  disableTypes:boolean = false;
  pageload: boolean;
  helphtml;
  linkhtml;
  vehicleTerm:any="";
  vehicleType:any="";
  permitType:any="";
  referenceNum:any="";
  selectedPermit:any = null;
  selectedPermitId:any="";
  tabload:boolean=false;
    private activeTab = new Subject<number>();

defaultValue: string;

  constructor(private sanitizer: DomSanitizer,
    public currformat: CurrencyFormat, private showModal:PopupService,
     private permitTypeService: PermitTypeService,private toastService:ToastNotificationService,
     public applicationService: ApplicationService,private route: ActivatedRoute,
     public utility: UtilityServiceService,private toastr: ToastrService,private router:Router,
     private permitService:PermitService,private activeRoute: ActivatedRoute,private carrierService: CarrierService) { }

  ngOnInit() {
    
    this.utility.confirmCtrl = false;
   //console.log(this.ctrlData);
    
    this.getPermitType();
    this.setHTMLDATA();
    if(this.ctrlData.data.id!=undefined && this.ctrlData.data.id!=null){
      this.vehicleType=this.ctrlData.vehicleType;
      this.vehicleTerm=this.ctrlData.vehicleTerm;
      this.referenceNum=this.ctrlData.data.reference_num;
      //console.log(this.referenceNum);
      this.selectedPermit=this.ctrlData.data.permit_type;
      //console.log(this.selectedPermit.id);
      this.selectedPermitId=this.selectedPermit.id;
      //console.log(this.ctrlData.permitSelectIndex);
    }
    //if(this.router.url.indexOf('edit') > 0){
     // this.activeRoute.params.subscribe((params: Params) => {
     //   this.ctrlData.application.id=  params['id'];
    //  });
      this.getApplication();
    //}
  }
  getCarrier(){
    this.pageload = true;
    this.carrierService.getById(this.ctrlData.data.carrier.id).subscribe(result => {
      this.setCarrierData(result);
      this.pageload = false;
    }, error => {
      this.pageload = false;
      //console.log(error);
    });
  }
  setCarrierData(data){
    data.account_balance = data.account_balance != 0 ? this.currformat.transform(parseFloat(data.account_balance)) : 'R 0.00';
    this.ctrlData.carrier = data;
    //console.log(this.ctrlData.carrier);
  }
  getApplication(){
    //console.log("getApplication");
    //console.log(this.ctrlData.data.id);
    if(this.ctrlData.data.id !== null && this.ctrlData.data.id !== undefined){
      this.applicationService.getById(this.ctrlData.data.id).subscribe((data:any) =>{
        //console.log(data.permit);
        this.ctrlData.permit = data.permit;
        this.ctrlData.application = data;
        this.ctrlData.carrierId = data.carrier_id;
        this.ctrlData.permit.id = data.permit.id
        this.referenceNum = data.reference_num;
        this.ctrlData.application.permit_type_id = data.permit_type_id;
        this.getPermitTypeForEdit(data.permit_type_id);
      })
    }
    
  }

  getPermitTypeForEdit(id){
    this.permitTypeService.getById(id).subscribe((x:any) => {
      //console.log(" start received permit");
      //console.log(x);
      //console.log(" end received permit");
      this.ctrlData.permittype=x;
      // this.dataCntrl.permit = x;
      this.defaultValue = x.description;
      this.vehicleTerm = x.temp_long_ind;
      this.vehicleType = x.freight_passenger_ind;
      this.ctrlData.selectedtype = x.code+'-'+x.description
      this.ctrlData.permittypeSelected = true;
      this.selectedPermitId = x.id;
      let indexVal:any=document.getElementById("idCtype") as HTMLSelectElement;
      if(indexVal!=null){
      //console.log(indexVal.selectedIndex);
      this.ctrlData.permitSelectIndex=indexVal.selectedIndex;
      }
  //console.log(this.defaultValue)
  this.utility.confirmCtrl = true;
  
    })
  }

  getPermitType() {
    this.pageload = true;
    this.permitTypeService.getAll().subscribe(result => {
      ////console.log(result);
      this.permittype = result;
    //  this.setPermitData(result)
      setTimeout(()=>{
        //console.log(this.ctrlData.data.permit_type_id);
        var indexVal1:any=document.getElementById("idCtype") as HTMLSelectElement;
        if(indexVal1!=undefined && indexVal1!="" && indexVal1!=null){
          indexVal1.selectedIndex=this.ctrlData.data.permit_type_id;
        }
      },100);
      this.setHTMLDATA()
      this.pageload = false;
    }, error => {
      this.pageload = false;
      //console.log(error);
    });
  }

  onChange(){
    //console.log(this.selectedPermit);
        this.ctrlData.permittypeSelected = true;
        this.ctrlData.data.permit_type_id = this.selectedPermit.id;
        this.ctrlData.selectedtype = this.selectedPermit.code+'-'+this.selectedPermit.description;
        this.ctrlData.permittype=this.selectedPermit;
        this.selectedPermitId=this.selectedPermit.id;
        let indexVal:any=document.getElementById("idCtype") as HTMLSelectElement;
        if(indexVal!=null){
          //console.log(indexVal.selectedIndex);
          this.ctrlData.data.permit_type_id=indexVal.selectedIndex;
        }
  }

  setPermitData(data){
    data.forEach(element => {
      element.fee = this.currformat.transform(parseFloat(element.current_fee));
    });
   // this.permittype = data;

    if(this.ctrlData.isViewEditControl == true){
      this.editMode = this.ctrlData.editMode;
   //   this.setSelectedType();
    }
  }

  setHTMLDATA(){

    if(environment.authWebApi.systemData!=null){
      let link = environment.authWebApi.systemData.Configurations.find(p=>p.Code=='iCBMSLinks2');
      let help = environment.authWebApi.systemData.Configurations.find(p=>p.Code=='iCBMSLand2');
      this.linkhtml = this.sanitizer.bypassSecurityTrustHtml(link.Value);
      this.helphtml = this.sanitizer.bypassSecurityTrustHtml(help.Value);
    }
  }

  setSelectedType(){
    this.selectedIndex = this.permittype.findIndex(p=>p.id == 11);
  }

  onSelectType(index,item){
    {
      this.selectedIndex = index;
      this.ctrlData.permittypeSelected = true;
      this.ctrlData.application.permit_type_id = item.id;
      this.ctrlData.selectedtype = `${item.code} - ${item.description}`;
      this.ctrlData.permittype = item;
    }
  }

  selectVehicleTerm(termVal){
    this.vehicleTerm=termVal;
    this.ctrlData.vehicleTerm=this.vehicleTerm;
  }
  selectVehicleType(typeVal){
    //console.log(typeVal)
    this.vehicleType=typeVal;
    this.ctrlData.vehicleType=this.vehicleType;
  }

  myRef(reference){
    //console.log(reference)
    this.referenceNum = reference;
  }
  saveApplication() {
    this.pageload = true;

    this.ctrlData.application.date_modified = this.ctrlData.application.date_created = new Date();
    this.ctrlData.application.user_modified = this.ctrlData.application.user_created = environment.authWebApi.userData.User.FirstName;
    this.ctrlData.application.reference_num = this.referenceNum;
// if(this.dataCntrl.permit.permit_type_id === undefined){
//   this.pageload = false;
//   return this.toastr.warning('Please select Permit Type first!','Permit Type');
// }
//console.log(this.ctrlData.permit);
//console.log(this.ctrlData.application)
if(this.ctrlData.application.id==undefined && this.ctrlData.application.id==null){
  this.applicationService.postApplication(this.ctrlData.application)
  .subscribe((result:any) => {
    this.ctrlData.application = result;
    this.ctrlData.permit.permit_type_id = result.permit_type_id;
    this.ctrlData.permit.application_id = result.id;
  this.savePermit();
  this.pageload = false;



  },
    error => {
    //  this.tabload = false;
    this.toastService.error('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.')

      // this.showModal.showError('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.', error);
      return;
    });
}else{
  //console.log(this.ctrlData.permit);

 this.updateApplication();
  this.updatePermit();
  this.pageload = false;

}

  }

  cancelApplication(){
    if(this.ctrlData.application.id==undefined && this.ctrlData.application.id==null){
      this.router.navigate(['/carrier/permit/application/'+this.ctrlData.carrierID]);
    }else{
      this.showModal.showConfirm('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.deleteApplication()
        } else {
          return;
        }
      });
    }
  }
  deleteApplication(){
    //console.log("delete application");
    this.pageload = true;

    this.permitService.deletePermit(this.ctrlData.permit.id).subscribe(x =>{
      //console.log(x);
    this.deleteApp(this.ctrlData.application.id);
    this.pageload = false;

    this.router.navigate(['/carrier/permit/application/'+this.ctrlData.carrierID]);

    })
//this.dataCntrl.application.id
//this.dataCntrl.permit.id
  }
  deletePermit(id){
    this.permitService.deletePermit(id).subscribe(x =>{
      //console.log(x);
    })

  }
  deleteApp(id){
    this.applicationService.deleteApplication(id).subscribe(x =>{
      //console.log(x);
    })
  }
  savePermit(){
    this.ctrlData.permit.date_modified = this.ctrlData.permit.date_created = new Date();
    this.ctrlData.permit.user_modified = this.ctrlData.permit.user_created = environment.authWebApi.userData.User.Username;
    this.ctrlData.permit.permit_fee = this.ctrlData.permittype.current_fee == null ? 0 : this.ctrlData.permittype.current_fee ;
    this.ctrlData.permit.application_fee = this.ctrlData.permittype.current_application_fee == null ? 0 : this.ctrlData.permittype.current_application_fee ;
    this.permitService.postPermit(this.ctrlData.permit)
    .subscribe(result => {
      this.ctrlData.permit = result;
      this.tabload = false;
      this.toastService.success('Saved Permit Type Successfully','Permit Type');
       this.applicationService.setTab(2);
       this.utility.confirmCtrl = true;
    },
      error => {
        this.tabload = false
        this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.', error)

        return;
      });
  }

  updatePermit(){
    this.ctrlData.permit.date_modified = this.ctrlData.permit.date_created = new Date();
    this.ctrlData.permit.user_modified = this.ctrlData.permit.user_created = environment.authWebApi.userData.User.Username;
    this.ctrlData.permit.permit_fee = this.ctrlData.permittype.current_fee == null ? 0 : this.ctrlData.permittype.current_fee ;
    this.ctrlData.permit.application_fee = this.ctrlData.permittype.current_application_fee == null ? 0 : this.ctrlData.permittype.current_application_fee ;
    this.permitService.upadatePermit(this.ctrlData.permit).subscribe(result => {
      this.ctrlData.permit = result;
      this.toastService.success('Updated Permit Type Successfully','Permit Type');


    })

  }
  updateApplication(){
    this.applicationService.putApplication(this.ctrlData.application).subscribe((x:any) => {
      this.ctrlData.application = x;
    this.ctrlData.permit.permit_type_id = x.permit_type_id;
    this.ctrlData.permit.application_id = x.id;

    })
  }

}
